import { render } from "./AdminTable.vue?vue&type=template&id=ca9d34d2&scoped=true"
import script from "./AdminTable.vue?vue&type=script&lang=js"
export * from "./AdminTable.vue?vue&type=script&lang=js"

import "./AdminTable.vue?vue&type=style&index=0&id=ca9d34d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca9d34d2"]])

export default __exports__